export default "<div data-dojo-attach-point=\"rootContainer\" style=\"display:flex; flex-direction:column; gap:8px;\"></div>\n"